<template>
    <Teleport to="body">
        <div
            v-if="isOpen"
            class="
                bg-black bg-opacity-25
                fixed
                top-0
                left-0
                w-full
                h-full
                flex
                items-center
                justify-center
            "
            :style="{
                zIndex: zIndex ?? 101,
            }"
            @click.self="$emit('close')"
        >
            <div
                class="
                    bg-white
                    rounded-lg
                    shadow-lg
                    p-4
                    relative
                    font-sans
                    min-w-[30vw]
                    max-w-[90vw]
                "
            >
                <header class="flex items-center mb-4" v-if="title">
                    <h3 class="mr-12 font-semi-bold text-lg">{{ title }}</h3>
                    <button
                        type="button"
                        class="
                            rounded-md
                            ml-auto
                            leading-[0]
                            p-1
                            hover:bg-gray-100
                        "
                        @click="$emit('close')"
                    >
                        <ion-icon name="close"></ion-icon>
                    </button>
                </header>
                <slot></slot>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: "ModalCustom",
    props: ["title", "isOpen", "zIndex"],
};
</script>

<style scoped></style>
